import { render, staticRenderFns } from "./TableFormInput.vue?vue&type=template&id=2d7801a4&scoped=true"
import script from "./TableFormInput.vue?vue&type=script&lang=js"
export * from "./TableFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7801a4",
  null
  
)

export default component.exports